import { combineReducers } from 'redux';

import { errorModalReducer } from './errorModalReducer';
import { exchangeInfoReducer } from './exchangeInfo';
import { exchangeInfoStatsReducer } from './exchangeInfoStats';
import { signatureModalReducer } from './exchangeSignatureModal';
import { selectedChartReducer } from './selectedChartReducer';
import { userGuideReducer } from './userGuideReducer';
import { websocketStateReducer } from './websocketStateReducer';

export const exchangeReducer = combineReducers({
  info: exchangeInfoReducer,
  infoStats: exchangeInfoStatsReducer,
  userGuide: userGuideReducer,
  websocketState: websocketStateReducer,
  signatureModal: signatureModalReducer,
  errorModal: errorModalReducer,
  selectedChart: selectedChartReducer,
});
